import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaStar, FaUserTag } from "react-icons/fa";
import loadImage from '../assets/imageLoader';
import Button from "./ui/Button";

function WorkerCard({ worker }) {
    // Safe Access
    const workerId = worker?.id;
    const name = worker?.profile?.name || "N/A";
    const picture = worker?.profile?.picture;
    const district = worker?.profile?.location?.district;
    const division = worker?.profile?.location?.division;
    const rating = worker?.profile?.rating || 0;
    const skills = worker?.categories?.map(c => c.Name).slice(0, 3) || []; // Top 3 skills

    const isBroker = worker.isBroker;

    return (
        <motion.div
            whileHover={{ y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
            className="bg-white rounded-2xl shadow-sm hover:shadow-xl border border-slate-100 overflow-hidden flex flex-col h-full group transition-all duration-300"
        >
            {/* Image Section */}
            <div className="relative h-48 overflow-hidden bg-slate-100">
                <Link to={`/workers/profile/${workerId}`}>
                    <img
                        src={loadImage(picture)}
                        alt={name}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                </Link>

                {/* Badges */}
                <div className="absolute top-3 right-3 flex flex-col gap-2">
                    {isBroker && (
                        <span className="bg-purple-600 text-white text-xs font-bold px-2 py-1 rounded-lg shadow-sm">
                            Broker
                        </span>
                    )}
                    <span className="bg-white/90 backdrop-blur-sm text-slate-800 text-xs font-bold px-2 py-1 rounded-lg shadow-sm flex items-center gap-1">
                        <FaStar className="text-amber-400" /> {rating.toFixed(1)}
                    </span>
                </div>
            </div>

            {/* Content Section */}
            <div className="p-5 flex flex-col flex-grow">
                <div className="mb-4">
                    <Link to={`/workers/profile/${workerId}`}>
                        <h3 className="text-lg font-bold text-slate-800 group-hover:text-brand-primary transition-colors line-clamp-1">
                            {name}
                        </h3>
                    </Link>

                    <div className="flex items-center text-slate-500 text-sm mt-1">
                        <FaMapMarkerAlt className="mr-1 text-brand-secondary" />
                        <span className="truncate">
                            {district}{division ? `, ${division}` : ''}
                        </span>
                    </div>
                </div>

                {/* Skills Tags */}
                <div className="flex flex-wrap gap-2 mb-4">
                    {skills.length > 0 ? (
                        skills.map((skill, i) => (
                            <span key={i} className="px-2 py-1 bg-slate-50 text-slate-600 text-xs rounded-md border border-slate-200">
                                {skill}
                            </span>
                        ))
                    ) : (
                        <span className="text-xs text-slate-400 italic">No skills listed</span>
                    )}
                </div>

                {/* Action Button */}
                <div className="mt-auto pt-4 border-t border-slate-100">
                    <Link to={`/workers/profile/${workerId}`} className="block w-full">
                        <Button variant="outline" fullWidth className="py-2 text-sm group-hover:bg-brand-primary group-hover:text-white group-hover:border-brand-primary transition-all">
                            View Profile
                        </Button>
                    </Link>
                </div>
            </div>
        </motion.div>
    );
}

export default WorkerCard;
